import React from 'react';
import PropTypes from 'prop-types';
import Story from '../stories/Story';
import SectionHeader from '../../components_profiles/SectionHeader';
import useStoriesForUser from './useStoriesForUser';
import Loader from '../../components/Loader';
import useShowMorePagination from './shared/useShowMorePagination';
import useStableList from './shared/useStableList';
import ShowMoreButton from './shared/ShowMoreButton';

Stories.propTypes = {
  user: PropTypes.object.isRequired
};

export default function Stories(props) {
  const { user, id } = props;

  const { showAll, showMore, page, pageSize } = useShowMorePagination();
  const storiesRes = useStoriesForUser(user, { page, pageSize });
  const { data, isFetching, meta } = useStableList(storiesRes);

  const storiesCount = data.length;
  const totalCount = (meta && meta.totalCount) || 0;
  const totalExtra = Math.max(0, totalCount - storiesCount);

  function handleShowMore() { showMore(); }

  if (storiesCount === 0) {
    return null;
  }

  return (
    <div id={id} className="space-y-4">
      <SectionHeader
        title="Impact Stories"
        subtitle="Curated stories of past projects I've done and the impact they had on the students and people involved."
      />
      <div className="grid grid-cols-1 sm:grid-cols-2 gap-8">
        {data.map(function(story) {
          return (
            <Story
              key={story.id || story.cid}
              story={story}
            />
          );
        })}
        {totalExtra > 0 && !showAll && (
          <ShowMoreButton count={totalExtra} onClick={handleShowMore} disabled={isFetching} noun="stories" />
        )}
        {isFetching && <Loader />}
      </div>
    </div>
  );
};
